import * as React from 'react';

import Breadcrumbs from 'src/components/common/Breadcrumbs';
import MyOrders from 'src/components/MyOrders';

import './OrdersView.scss';

const OrdersView: React.FC = (props: any) => {
  const { t } = props;
  return (
    <div className="rp-orders-view">
      <Breadcrumbs>
        {t('common.home')} / {t('myOrders.breadCrumbTitile')}{' '}
      </Breadcrumbs>
      <MyOrders />
    </div>
  );
};

export default OrdersView;
